export default "__VITE_ASSET__DRfcQOXA__"